import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';
import SelectMultiplo from '../SelectMultiplo';

function ModalEditarLinhaAtendimento({ currentPage }) {

    const { setModalEditar, DemandaAtual, Pessoas, EditarLinha, Permissao, ListaArea, Areas, ListaAreaLinha, LinhaArea, LinhaAtualKey, setEdicaoLinha, Cargos, ListaCargo, ListaPessoaPorCargo, PessoasPorCargo, ListaLinhaPessoas, AdicionarLinhaPessoa, ExcluirLinhaPessoa, ItensLinha } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [Nome, setNome] = useState(DemandaAtual?.nome)
    const [Descricao, setDescricao] = useState(DemandaAtual?.descricao)
    const [Status, setStatus] = useState(true)
    const [Responsavel, setResponsavel] = useState(DemandaAtual?.responsavel?.key)
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);
    const [cargoKey, setCargoKey] = useState("")
    const [pessoaKey, setPessoaKey] = useState("")
    const areasOptions = (Areas || []).map((org) => ({
        label: org.descricao,
        value: org.key,
    }));

    const editarItensDemanda = (e) => {
        if (e) e.preventDefault();
        EditarLinha(Nome, Descricao, Status, Responsavel, currentPage)
            .then(() => {
                setModalEditar(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    useEffect(() => {
        ListaArea()
        ListaAreaLinha()
        ListaCargo()
        ListaLinhaPessoas()
    }, [])

    useEffect(() => {
        if (LinhaArea && LinhaArea.length > 0) {
            const selecionadas = LinhaArea.map((item) => ({
                label: item?.descricao,
                value: item?.key,
            }));
            setAreasSelecionadas(selecionadas);

            const novasAreas = LinhaArea.map((item) => ({
                areaKey: item?.key,
                linhaAtendimentoDemandaKey: LinhaAtualKey,
            }));

            setEdicaoLinha((prev) => ({
                ...prev,
                areas: novasAreas,
            }));
        }
    }, [LinhaArea]);

    useEffect(() => {
        if (cargoKey) {
            ListaPessoaPorCargo(cargoKey)
        }
        setPessoaKey("")
    }, [cargoKey])


    const Adicionar = (pessoaKey, cargoKey) => {
        AdicionarLinhaPessoa(pessoaKey, cargoKey)
            .then(() => {
                setCargoKey(0)
                setPessoaKey(0)
            })
    }

    const handleAreasEditChange = (selectedOptions) => {
        setAreasSelecionadas(selectedOptions);

        const novasAreas = selectedOptions.map((org) => ({
            areaKey: org.value,
            linhaAtendimentoDemandaKey: LinhaAtualKey,
        }));

        setEdicaoLinha((prev) => ({
            ...prev,
            areas: novasAreas,
        }));
    };



    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <div>
                        <h1 className="h1-modal">Editar cadastro</h1>
                    </div>
                    <div className="btn-close-modal" onClick={() => setModalEditar(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div className="modal-content">
                    <form className="mb-3">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Geral</span>}>
                                <Row style={{ alignItems: 'center' }}>
                                    <Col xs={10}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Time</Form.Label>
                                            <Form.Control maxLength={100} defaultValue={DemandaAtual.nome} onChange={(e) => setNome(e.target.value)} name="nome" />
                                        </Form.Group>
                                    </Col>
                                    <Col className='mt-2'>
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" defaultChecked={DemandaAtual.ativo} onChange={(e) => setStatus(e.target.checked)} />
                                            <p className='modal-status'>Ativo</p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Responsável</Form.Label>
                                            <Form.Select aria-label="Default select example" defaultValue={DemandaAtual?.responsavel?.key} onChange={(e) => setResponsavel(e.target.value)} name="responsavelKey">
                                                <option value="">Selecione</option>
                                                {Pessoas && Pessoas?.map((l) => {
                                                    return (
                                                        <option key={l.id}
                                                            value={l.key}
                                                            selected={l.key == DemandaAtual?.responsavel?.key ? true : false}
                                                        >
                                                            {l.nome}</option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área Solicitante</Form.Label>
                                            <SelectMultiplo
                                                options={areasOptions}
                                                value={areasSelecionadas}
                                                onChange={handleAreasEditChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control maxLength={255} defaultValue={DemandaAtual.descricao} onChange={(e) => setDescricao(e.target.value)} name="descricao" as="textarea" rows={3} />
                                    </Form.Group>
                                </Row>
                            </Tab>
                            <Tab eventKey="pessoas" title={<span>Pessoas</span>}>
                                <Row style={{ alignItems: 'center' }}>
                                    <Col xl={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cargo</Form.Label>
                                            <Form.Select aria-label="Default select example" value={cargoKey} onChange={(e) => setCargoKey(e.target.value)} name="cargoKey">
                                                <option value="0">Selecione</option>
                                                {Cargos &&
                                                    Cargos?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.descricao}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xl={5}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pessoa</Form.Label>
                                            <Form.Select aria-label="Default select example" value={pessoaKey} onChange={(e) => setPessoaKey(e.target.value)} name="pessoaKey">
                                                <option value="0">Selecione</option>
                                                {PessoasPorCargo &&
                                                    PessoasPorCargo?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key}>{item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xl={2}>
                                        <button type="button" className="btn-dash btn-ver mt-3" style={btnVer} onClick={() => Adicionar(pessoaKey, cargoKey)}>Adicionar</button>
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="secao-comentario">
                                        {ItensLinha &&
                                            ItensLinha?.map((item, index) => {
                                                return (
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                            <p className="p-title" style={{ marginLeft: '5px' }}>Cargo</p>
                                                            <span>{item.cargo.descricao}</span>
                                                        </div>
                                                        <div className="div-comentario" style={{ flexDirection: 'column', alignItems: 'start' }}>
                                                            <p className="p-title" style={{ marginLeft: '5px' }}>Pessoa</p>
                                                            <span>{item.pessoa.nome}</span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirLinhaPessoa(item.key)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>

                    </form>
                </div>
                <div className="footer-modal">
                    <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditar(false)}>Cancelar</button>
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                            e.preventDefault();
                            editarItensDemanda();
                        }}>Salvar</button>
                    }
                </div>
            </div>
        </div >
    )
}

export default ModalEditarLinhaAtendimento